<script lang="ts" setup>
export interface WidgetWizardItemBubbleProps {
    data: WizardData
}

const props = defineProps<WidgetWizardItemBubbleProps>()
</script>

<template>
  <Box
    color="azure"
    size="small"
    padding="p-6"
  >
    <div
      v-if="props.data.bubble && props.data.bubble.tags.length > 0"
      class="d-flex gap-2 mb-2"
    >
      <Label
        v-for="(tag, index) in props.data.bubble.tags"
        :key="index"
        :label="tag.name"
        :text-color="tag.color"
        :background-color="tag.background"
      />
    </div>

    <div class="d-md-flex justify-content-between">
      <Typo class="mb-2 mb-md-0">
        <p class="fs-biggest mb-0">
          {{ props.data.bubble?.text.normal }}
          <br>
          <strong>{{ props.data.bubble?.text.bold }}</strong>
        </p>
      </Typo>

      <slot name="cta" />
    </div>
  </Box>
</template>
